module.exports = __webpack_public_path__ + "static/acupun_2_md-a472b01cb48d4f15a0148bd25e50b14d.png";